import type { JSX } from "react";

export interface Citation {
  id: string;
  title: string;
  preview: string;
  user_metadata?: string | null;
  source?: string;
  source_ref?: string;
  external_url?: string;
}

interface CitationCardProps {
  citation: Citation;
  onSourceClick?: (sourceId: string) => void;
}

export function CitationCard({ citation: c, onSourceClick }: CitationCardProps): JSX.Element {
  return (
    <li>
      {onSourceClick ? (
        <button
          type="button"
          onClick={() => onSourceClick(c.id)}
          className="text-body-3 font-medium text-primary hover:underline cursor-pointer text-left"
        >
          {c.title}
        </button>
      ) : (
        <p className="text-body-3 font-medium text-foreground">{c.title}</p>
      )}
    </li>
  );
}

export function SourcesBlock({
  citations,
  compact = false,
  onSourceClick,
}: {
  citations: Citation[];
  compact?: boolean;
  onSourceClick?: (sourceId: string) => void;
}): JSX.Element {
  return (
    <details className="group mt-3 text-label-2">
      <summary
        className={
          compact
            ? "cursor-pointer list-none text-label-3 text-muted-foreground hover:text-foreground"
            : "cursor-pointer list-none text-muted-foreground hover:text-foreground"
        }
      >
        <span className="mr-1 inline-block transition-transform group-open:rotate-90">▸</span>
        <span className="uppercase tracking-wider">sources · {citations.length}</span>
      </summary>
      <ul className="mt-2 space-y-1">
        {citations.map((c) => (
          <CitationCard key={c.id} citation={c} {...(onSourceClick ? { onSourceClick } : {})} />
        ))}
      </ul>
    </details>
  );
}
